import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import Button from "components/Button";
import { PageTop, Title, TitleArea } from "components/LayoutParts";
import Loading from "components/Loading";
import UserModal, { UserModalConfig } from "components/UserModal";
import {
  PIT_PORT_PAGINATION_DEFAULT_INDEX,
  PIT_PORT_PAGINATION_DEFAULT_SIZE,
  PIT_PORT_PAGINATION_DEFAULT_TOTAL_PAGES,
} from "pages/PitPort/constants/pagination";
import { useFindOwnerUsers } from "pages/PitPort/OwnerEntity/api";
import DataTable from "pages/PitPort/OwnerEntity/OwnerUser/DataTable";

import ActionArea from "./DataTable/ActionArea";

const ButtonWrap = styled.div`
  margin-left: auto;
`;

/**
 * 貸主ユーザー一覧画面
 */
const OwnerUsers = () => {
  const navigate = useNavigate();
  const { id: ownerEntityId } = useParams();
  const onClickUserAdd = () => navigate(`/pit_port/owner-entities/${ownerEntityId}/owner-users/create`);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(PIT_PORT_PAGINATION_DEFAULT_INDEX);
  const [totalPages, setTotalPages] = useState<number>(PIT_PORT_PAGINATION_DEFAULT_TOTAL_PAGES);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [originList, setOriginList] = useState<OwnerUser[]>([]);
  const [isModalShow, setIsModalShow] = useState(false);
  const hideModal = () => setIsModalShow(false);
  const showModal = () => setIsModalShow(true);

  const ownerUserModalConfig: UserModalConfig = {
    onClickOutside: hideModal,
    subtitle: "送信に失敗しました",
    main: {
      buttonType: "secondary",
      onClick: hideModal,
      label: "閉じる",
    },
  };

  const { data, error } = useFindOwnerUsers({
    ownerEntityId: ownerEntityId ?? "1",
    pageIndex: currentPageIndex,
    pageSize: PIT_PORT_PAGINATION_DEFAULT_SIZE,
    keyword: searchKeyword,
  });

  const fetch = useCallback(async () => {
    if (error) {
      showModal();
      return;
    }
    if (!data) return;
    setTotalPages(data.totalPages);
    setOriginList(data.data);
  }, [data, error]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKeyword(e.target.value);
  };

  return (
    <>
      <PageTop />
      <TitleArea>
        <Title>貸主ユーザー</Title>
        <ButtonWrap>
          <Button label="貸主ユーザを追加" onClick={onClickUserAdd} type="primary" />
        </ButtonWrap>
      </TitleArea>
      <ActionArea searchKeyword={searchKeyword} onSearchChange={onSearchChange} />
      {data ? (
        <DataTable
          userList={originList}
          ownerEntityId={ownerEntityId ?? ""}
          totalPages={totalPages}
          pageIndex={currentPageIndex}
          setPageIndex={setCurrentPageIndex}
        />
      ) : (
        <Loading />
      )}
      <UserModal isVisible={isModalShow} config={ownerUserModalConfig}></UserModal>
    </>
  );
};

export default OwnerUsers;
